var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 100,
    viewBox: "0 0 73 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 80.6264L0.604843 79.7797L29.21 25.5022L29.2704 24.9276L16.661 1.2418C15.604 -0.742248 12.6296 -0.240539 12.2832 1.98054L0 80.6264Z",
    fill: "#FFC24A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.356934 79.9807L0.814199 79.0887L29.1199 25.3798L16.5415 1.59778C15.4963 -0.365465 12.8415 0.135105 12.4985 2.33282L0.356934 79.9807Z",
    fill: "#FFA712"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_40_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.356934 79.9807L0.814199 79.0887L29.1199 25.3798L16.5415 1.59778C15.4963 -0.365465 12.8415 0.135105 12.4985 2.33282L0.356934 79.9807Z",
    fill: "#FC9329"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.463 42.8434L47.8519 33.228L38.4602 15.2992C37.5687 13.6021 35.0796 13.5969 34.1975 15.2992L29.1796 24.8682V25.683L38.4628 42.8434H38.463Z",
    fill: "#F4BD62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2955 42.4428L47.4234 33.0947L38.2955 15.7138C37.4288 14.0639 35.3231 13.891 34.4655 15.5457L29.4214 25.2633L29.2704 25.7602L38.2955 42.4428Z",
    fill: "#FFA50E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_40_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2955 42.4428L47.4234 33.0947L38.2955 15.7138C37.4288 14.0639 35.3231 13.891 34.4655 15.5457L29.4214 25.2633L29.2704 25.7602L38.2955 42.4428Z",
    fill: "#F8942E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 80.6261L0.274074 80.3503L1.27009 79.9458L37.8732 43.4786L38.337 42.2162L29.206 24.8162L0 80.6261Z",
    fill: "#DC750C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6356 99.0173L72.7624 80.5424L63.3026 22.2817C63.0065 20.4589 60.7704 19.7384 59.4655 21.0452L0 80.6261L32.9368 99.0159C33.9605 99.5874 35.1135 99.8876 36.286 99.8879C37.4585 99.8881 38.6116 99.5884 39.6356 99.0173Z",
    fill: "#FDE068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4656 80.3875L63.0775 22.5692C62.7841 20.7601 60.9242 20.0117 59.6294 21.3088L0.367554 80.5128L32.9428 98.7202C33.9587 99.2875 35.1029 99.5854 36.2665 99.5857C37.4301 99.586 38.5744 99.2887 39.5906 98.7219L72.4658 80.3872L72.4656 80.3875Z",
    fill: "#FCCA3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6353 98.4728C38.6113 99.0439 37.4583 99.3436 36.2858 99.3434C35.1133 99.3431 33.9604 99.0429 32.9367 98.4714L0.265201 80.3461L0.000244141 80.6261L32.9367 99.0159C33.9605 99.5874 35.1134 99.8876 36.286 99.8879C37.4585 99.8881 38.6116 99.5884 39.6356 99.0173L72.7623 80.5424L72.6812 80.0432L39.6356 98.4731L39.6353 98.4728Z",
    fill: "#EEAB37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_40_310",
    x: 0.356934,
    y: 0.37085,
    width: 28.7629,
    height: 79.6099,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_40_310"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_40_310",
    x: 29.2704,
    y: 7.38721,
    width: 19.153,
    height: 35.0557,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_40_310"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.9345,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.a3c83459899330d3a5abfed01d96f254.svg";
export { ForwardRef as ReactComponent };